export const ACTION_RESET = "ACTION_RESET";

export interface ActionReset {
  readonly type: typeof ACTION_RESET;
}

export default (): ActionReset => ({
  type: ACTION_RESET,
});
